import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA that appears once the user scrolls past the first CTA button.
 * Shakes slightly and quickly to draw attention.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const update = () => {
      if (!anchor) {
        setVisible(window.scrollY > 500);
        return;
      }
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-30" data-mp="33i5uu269lj9t">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-cream/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 backdrop-blur-sm" data-id="element-31" data-mp="2z1phrb597y9h">
          <div className="mx-auto w-full max-w-md" data-id="element-32" data-mp="2fe8clnj8shon">
            <a href={CHECKOUT_URL} className="flex w-full animate-shake items-center justify-center gap-2 rounded-2xl bg-gold px-4 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(184,145,47,0.95)] transition-colors hover:bg-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark sm:text-base" data-id="element-33" data-mp="2fcndrlpwackz">
              <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-34" data-mp="9l9x5js7q7lk" />
              Get instant access — $27
            </a>
            <p className="mt-1.5 text-center text-[10px] font-medium text-ink-soft" data-id="element-35" data-mp="77wo0uvv7rbr">
              One-time payment · Lifetime access · 7-day guarantee
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}